import { useMutation, useQuery } from "@tanstack/react-query";
import axiosPrivate from "../axiosPrivate";

export const useLoanProducts = () =>
  useQuery({
    queryKey: ["loanProducts"],
    queryFn: async () => {
      const res = await axiosPrivate.get("loan-mgt/loan-products");
      return res.data;
    },
    staleTime: 1000 * 60 * 5,
  });

export const useLoans = () =>
  useQuery({
    queryKey: ["myLoans"],
    queryFn: async () => {
      const res = await axiosPrivate.get("loan-mgt/loans");
      return res.data;
    },
    staleTime: 1000 * 60 * 5,
  });


export const useLoanCalculator = () => {

  return useMutation({
    mutationFn: async (payload) => {
      const res = await axiosPrivate.post("loan-mgt/loan-products/repayment/calculator", payload);
      return res.data;
    },
    onError: (error) => {
      console.error("Login failed:", error?.response?.data || error.message);

      return error;
    },
  });
};

export const useBookLoan = () => {

  return useMutation({
    mutationFn: async (payload) => {
      const res = await axiosPrivate.post("loan-mgt/loans", payload);
      return res.data;
    },
    onError: (error) => {
      console.error("Book loan failed:", error?.response?.data || error.message);

      return error;
    },
  });
};
